import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'atx-collapse',
    template: `<div [collapse]="collapsed"
     (expanded)="fireExpanded.emit($event)"
     (collapsed)="fireCollapsed.emit($event)">
    <ng-content></ng-content>
</div>
`,
    styles: [``],
})

export class AtxCollapseComponent {
    @Input() public readonly collapsed: boolean;

    @Output('onExpanded') public readonly fireExpanded: EventEmitter<void> = new EventEmitter();
    @Output('onCollapsed') public readonly fireCollapsed: EventEmitter<void> = new EventEmitter();
}
